<!-- <h1>Issue Tracker</h1>
<ul>
    <li><a routerLink="home">Home</a></li>
    <li><a routerLink="user_management">User Management</a></li>
</ul> -->
<router-outlet></router-outlet>
